export const getMerchantConfiguratorContent = async (countryCode) => {
  const apiResponse = await fetch(
    `/studio/api/v1/merchant-configurator/content?country_code=${countryCode}`
  );
  return await apiResponse.json();
};
